import * as ss from 'superstruct';

export const RlClientConfig = ss.type({
  accessToken: ss.string(),
});

export type RlClientConfig = ss.Infer<typeof RlClientConfig>;
